import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import PropertyCard from 'components/PropertyCard';
import { animationKeyframes } from 'lib/animations';
import { useDataLayer } from 'hooks/useDataLayer';
import { usePersonalisation } from 'hooks/usePersonalisation';
import { PropertyCardProps } from 'types/property';
import useSelectItemEvent from 'hooks/useSelectItemEvent';
import { useSelector } from 'react-redux';
import { getQueryLocation, getQueryRecommended } from 'store/router/routerSelectors';
import { getResults } from 'store/search/searchSelectors';
import { useRouter } from 'next/router';
import { PageType } from 'lib/analytics/enums';

const TopCenterWrapper = styled.div`
  position: absolute;
  transform: translate(-50%, -100%) translateY(-39px);
  z-index: 1;
  min-width: 300px;
`;

const AnimationWrapper = styled.div`
  animation: ${animationKeyframes.fadeInSlideUp10} ease 250ms;
`;

const PositionedPropertyCard = (props: PropertyCardProps) => {
  const { id: propertyId } = props;
  const { emitInteractionEvent } = useDataLayer();
  const router = useRouter();
  const isRebooked = router.query.ss_action === 'rebook';
  const recommendedProperty = useSelector(getQueryRecommended);
  const { fireSelectItemEvent } = useSelectItemEvent();
  const location = useSelector(getQueryLocation);
  const searchResults = useSelector(getResults);
  const personalisation = usePersonalisation();
  const handlePropertyCardClick = useCallback(() => {
    const result = searchResults.find((r) => r.property.id === propertyId);
    if (result) {
      fireSelectItemEvent({
        listName: `Hotels in ${location}`,
        type: 'map',
        property: result.property,
        offer: result.offer,
        roomType: result.roomType,
        pageType: PageType.MAP,
        isRebooked: isRebooked,
        recommendedProperty: recommendedProperty,
      });
    }
    emitInteractionEvent({ type: 'Price Marker', value: 'Property Card Selected' });
    personalisation.trackMapClick(propertyId);
  }, [searchResults, emitInteractionEvent, personalisation, propertyId, fireSelectItemEvent, location, isRebooked, recommendedProperty]);

  return (
    <TopCenterWrapper>
      <AnimationWrapper data-testid="positioned-property-card-wrapper">
        <PropertyCard onClick={handlePropertyCardClick} {...props} showCampaignMessage showRatingTooltip={false} />
      </AnimationWrapper>
    </TopCenterWrapper>
  );
};

export default PositionedPropertyCard;
